import * as React from 'react'
function SvgExchange(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M10.6 20.6c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8L10.8 26H34c1.2 0 2 .8 2 2s-.8 2-2 2H10.8l2.6 2.6c.8.8.8 2 0 2.8-.4.4-.8.6-1.4.6-.6 0-1-.2-1.4-.6l-6-6c-.8-.8-.8-2 0-2.8zm16-16c.8-.8 2-.8 2.8 0l6 6c.8.8.8 2 0 2.8l-6 6c-.4.4-.8.6-1.4.6-.6 0-1-.2-1.4-.6-.8-.8-.8-2 0-2.8l2.6-2.6H6c-1.2 0-2-.8-2-2s.8-2 2-2h23.2l-2.6-2.6c-.8-.8-.8-2 0-2.8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgExchange
